var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31725 0.682617L1.33861 1.00258C0.914891 1.00258 0.597106 1.4292 0.597106 1.74916C0.491177 7.18852 1.33861 11.988 6.21132 16.894C11.084 21.8001 15.639 22.3334 21.0413 22.3334C21.465 22.3334 21.7828 22.0134 21.7828 21.5868L22.1006 16.5741C22.1006 16.1475 21.7828 15.8275 21.465 15.7209L16.4864 14.9743C16.2745 14.9743 15.9567 14.9743 15.8508 15.1876C14.6856 16.3608 13.8382 17.214 13.5204 17.4273C12.9907 17.214 11.084 16.3608 8.96546 14.121C6.84689 11.988 5.7876 9.85487 5.46982 9.3216C5.89353 8.89499 6.84689 7.9351 7.69431 7.08187C7.90617 6.86856 7.90617 6.65525 7.90617 6.44194L7.16467 1.32254C7.16467 1.00258 6.74096 0.682617 6.31725 0.682617Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.3f88a2871a4c168ece79382c71661c07.svg";
export { ForwardRef as ReactComponent };